(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ab-loyalty-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (!root || root.dataset.loyaltyBound) return;
    root.dataset.loyaltyBound = 'true';
    const app = root.querySelector('.ab-l-app');
    const update = () => {
      const slots = { '.lion-earn': 'loyalty-earn', '.lion-redeem': 'loyalty-rewards', '.lion-faq': 'loyalty-faq' };
      Object.entries(slots).forEach(([selector, id]) => {
        const target = app.querySelector(selector);
        if (target && !target.id) target.id = id;
      });
      if (app.querySelector('.lion-rules-list')) app.classList.add('is-ready');
      const page = app.querySelector('.lion-integrated-page');
      if (page) {
        const member = page.classList.contains('lion-integrated-page--authenticated');
        root.querySelectorAll('[data-loyalty-member-actions]').forEach((element) => { element.hidden = !member; });
        root.querySelectorAll('[data-loyalty-guest-actions]').forEach((element) => { element.hidden = member; });
      }
      const history = app.querySelector('.lion-history-table');
      if (history && !history.hasAttribute('tabindex')) history.setAttribute('tabindex', '0');
    };
    const observer = new MutationObserver(update);
    observer.observe(app, { childList: true, subtree: true });
    update();
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(root)) observer.disconnect();
    }, { once: true });
  };
  document.querySelectorAll('[data-loyalty-editorial]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-loyalty-editorial]').forEach(initialize);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ab-one-of-a-kind"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  var link=event.target.closest('.ab-ok a[data-ok-action]');
  if(!link)return;
  if(link.hash&&(link.dataset.okAction==='chapter'||link.dataset.okAction==='explore')){
    var target=document.getElementById(link.hash.slice(1));
    if(target){event.preventDefault();history.replaceState(null,'',link.hash);target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});target.focus({preventScroll:true});}
  }
  document.dispatchEvent(new CustomEvent('ab:collection-interaction',{detail:{variant:'ooak-editorial-v1',action:link.dataset.okAction,collection:link.dataset.okGroup||null,product_id:link.closest('[data-product-id]')?.dataset.productId||null}}));
},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ab-rare-stone-selection"]) return;
  try {
    
function initRareStones(){
const root=document.getElementById('ab-rare-stones');
if(!root || root.dataset.enhanced) return;
root.dataset.enhanced='true';
/* Local progressive enhancement: no network, storage, analytics or cart calls. */
root.querySelectorAll('[data-gallery]').forEach((media) => {
  const gallery = media.querySelector('.gallery');
  const controls = media.querySelector('.gallery-controls');
  const photos = [...gallery.children];
  if (!controls || photos.length < 2) return;
  const position = controls.querySelector('.position');
  let current = 0;
  function show(index, moveFocus = false) {
    current = (index + photos.length) % photos.length;
    gallery.scrollTo({left: current * gallery.clientWidth, behavior: 'instant'});
    position.textContent = controls.dataset.position.replace('[current]', current + 1).replace('[total]', photos.length);
    if (moveFocus) photos[current].focus({preventScroll:true});
  }
  controls.querySelector('[data-next]').addEventListener('click', () => show(current + 1));
  gallery.addEventListener('scroll', () => {
    if (!gallery.clientWidth) return;
    current = Math.round(gallery.scrollLeft / gallery.clientWidth);
    position.textContent = controls.dataset.position.replace('[current]', current + 1).replace('[total]', photos.length);
  }, {passive:true});
  gallery.addEventListener('keydown', (event) => {
    if(event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault(); show(current + (event.key === 'ArrowRight' ? 1 : -1), true);
    }
  });
  controls.hidden = false;
});
// Carry only incoming campaign parameters to AB. Do not invent internal UTMs.
const incoming = new URLSearchParams(location.search);
const keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
root.querySelectorAll('a[data-store-link]').forEach((a) => {
  const url = new URL(a.href);
  if(url.origin !== location.origin) return;
  for(const key of keys) if(incoming.has(key)) url.searchParams.set(key, incoming.get(key).slice(0,200));
  a.href = url.href;
});

// The reference's chapter links also move keyboard focus to the heading section.
root.querySelectorAll('[data-ok-action="chapter"], [data-ok-action="explore"]').forEach(link => {
  link.addEventListener('click', event => {
    const target = root.querySelector(link.hash);
    if (!target) return;
    event.preventDefault();
    history.replaceState(null, '', location.pathname + location.search + link.hash);
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    target.focus({preventScroll:true});
  });
});

}
initRareStones();
document.addEventListener('shopify:section:load',initRareStones);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ab-warm-edit"]) return;
  try {
    
function initWarmEdit(){
const root=document.getElementById('ab-warm-edit');
if(!root || root.dataset.enhanced) return;
root.dataset.enhanced='true';
const allowedParams = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const incoming = new URLSearchParams(window.location.search);

root.querySelectorAll("a[data-store-link]").forEach((anchor) => {
  const url = new URL(anchor.href);
  if (url.origin !== location.origin) return;
  for (const key of allowedParams) {
    if (incoming.has(key)) url.searchParams.set(key, incoming.get(key).slice(0, 200));
  }
  anchor.href = url.href;
});

root.querySelectorAll('[data-ok-action="explore"], [data-ok-action="chapter"]').forEach((anchor) => {
  anchor.addEventListener("click", (event) => {
    const target = root.querySelector(anchor.hash);
    if (!target) return;
    event.preventDefault();
    history.replaceState(null, "", location.pathname + location.search + anchor.hash);
    target.scrollIntoView({
      behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
    });
    target.focus({ preventScroll: true });
  });
});
}
initWarmEdit();
document.addEventListener('shopify:section:load',initWarmEdit);

  } catch(e) { console.error(e); }
})();
})();
